<template>
    <li v-if="!cart.info.saved && cart.itemList.length != 0"><!-- Note: only show save if 1: it hasn't been saved yet, 2:it's not empty -->
        <!-- Save Cart MENU LINK -->
        <a href="#" @click.prevent="toggleSaveCart" class="save-cart-vue">
            <i class="csi-iconfont csi-save"></i>
            {{labels[1023]}}
        </a><!--label: Save Cart -->

        <!-- MODAL WINDOW -->
        <modal v-if="showSaveModal" @close="closeSaveCartModal">
            <template v-slot:header>
                <span class="ui-dialog-title">
                    {{modalTitle}}
                </span>
            </template>

            <template v-slot:body>
                <div v-if="saveMsg.length" class="megapadding">
                    {{saveMsg}}
                </div>
                <div v-else>
                    <form name="frmSaveCart" @submit.prevent="saveSubmit" id="frmSaveCart" class="std">
                        <div>
                            <label for="cname">{{labels[1153]}}<!-- Name --></label>
                            <input type="text" name="cname" id="cname" class="form-control input-sm" v-model="cartName" required />
                            <!-- <label class="errorMsg">{{labels[1154]}}<!- Please enter a name for your cart. -></label> -->
                        </div>
                        <br />
                        <div>
                            <label for="cnotes">{{labels[1340]}}</label><!-- Notes -->
                            <textarea name="cnotes" id="cnotes" maxlength="1000" class="form-control input-sm" rows="4" v-model="cartNotes"></textarea>
                        </div>

                        <br />
                        <p>
                            <small><em>{{labels[1155]}}</em></small>
                        </p> <!-- Updates to your cart will save automatically. Saved carts can be loaded from the Customer Center. -->
                        <div v-if="getCartItemIndex(labels[2165])" class="alert alert-danger small">
                            {{labels[2166]}}
                        </div> <!-- label: Note: Data subscription items will not be saved. --><!-- label 2156: Data Subscriptions -->

                        <div v-if="loadingSaveCart">
                            <img src='/layouts/main/styles/images/spinner.gif' /> Saving
                        </div>

                        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                            <div class="ui-dialog-buttonset">
                                <button type="button" @click="closeSaveCartModal(false)" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                                    <span class="ui-button-text">{{labels[1030]}}</span><!-- label: Cancel -->
                                </button>
                                <button type="submit" class="btn-primary ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                                    <span class="ui-button-text">{{labels[1028]}}</span><!-- label: Save -->
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            </template>

            <template v-slot:footer>
                <!-- need the footer buttons inside the form in the body -->
                <span></span>
            </template>
        </modal>
    </li>
</template>

<script>
import Modal from '../../shared/components/Modal.vue'
import useCart from "../composables/useCart"
import useCMS from "../../shared/composables/useCMS"
import { ref, computed } from '@vue/composition-api';

export default {
    name: 'CartSave',
    components: {
        Modal
    },
    setup () {
        const { cart, showSaveModal, toggleSaveCart, saveCart, getCart } = useCart();
        const { labels } = useCMS();
        const { closeSaveCartModal, saveSubmit, getCartItemIndex, loadingSaveCart, cartName, cartNotes, saveMsg, modalTitle } = useSaveModal(labels, toggleSaveCart, cart, saveCart, getCart, showSaveModal);

        return {
            cart,
            showSaveModal,
            cartName,
            cartNotes,
            saveMsg,
            toggleSaveCart,
            closeSaveCartModal,
            saveSubmit,
            getCartItemIndex,
            loadingSaveCart,
            modalTitle,
            labels
        }
    }
}

function useSaveModal(labels, toggleSaveCart, cart, saveCart, getCart, showSaveModal) {

    const cartName = ref(cart.value.info.name);
    const cartNotes = ref(cart.value.info.notes);
    const saveMsg = ref('');
    const loadingSaveCart = ref(false);

    const closeSaveCartModal = () => {
        saveMsg.value = ''
        if (showSaveModal.value) {
            toggleSaveCart();
        }
    }

    const modalTitle = computed(() => cart.value.info.saved ? labels[1037] : labels[1023]);

    const saveSubmit = async () => {
        loadingSaveCart.value = true;

        try {
            const resp = await saveCart(cartName.value, cartNotes.value);
            if (resp.status === 200) {
                saveMsg.value = resp.data.msg;
                getCart();
            } else {
                alert(resp.data.msg);
            }
        } catch (err) {
            console.log(err);
        }

        loadingSaveCart.value = false;
    }

    const getCartItemIndex = (item) => {
        for (let i = 0; i < cart.value.itemList.length; i++) {
            if (cart.value.itemList[i].name == item) {
                return i;
            }
        }
    }

    return {
        closeSaveCartModal,
        saveSubmit,
        getCartItemIndex,
        loadingSaveCart,
        cartName,
        cartNotes,
        saveMsg,
        modalTitle
    }
}
</script>
